import { withLink } from './withLink';
export var Link = Object.assign(withLink('a'), {
  withLink: withLink
});